// extracted by mini-css-extract-plugin
export default {"header":"styles_header__SH+zj","alert":"styles_alert__DSlMC","alert_container":"styles_alert_container__XFYsC","row-centered":"styles_row-centered__G7YG-"};